import { Heading2, Text } from '@serodigital/ui-components';
import * as React from 'react';

const kindOf = {
  orange: ['bg-[#FB6B45]'],
  blue: ['bg-[#019E9E]'],
};

interface IColourCardProps {
  kind: keyof typeof kindOf;
  header: string | JSX.Element;
  label: string;
  disabled?: boolean;
  RightColumn?: JSX.Element;
}

const classNames = [
  'flex',
  'flex-row',
  'rounded-xl',
  'sero-shadow-tile',
  'border',
  'border-grey-neutral',
  'text-common-white',
  'p-24',
  'min-w-[12rem]',
  'space-x-8',
];
export function ColourCards({ kind = 'orange', header, label, disabled, RightColumn }: IColourCardProps) {
  const className = [...classNames];
  className.push(...kindOf[kind]);
  if (disabled) {
    className.push('opacity-40');
  }
  return (
    <div data-qa={`colour-cards-${kind}`} data-disabled={disabled ?? false} className={className.join(' ')}>
      <div className="flex flex-col ">
        <Heading2 className="p-0 m-0 text-common-white">{header}</Heading2>
        <Text>{label}</Text>
      </div>
      {RightColumn}
    </div>
  );
}
